exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".CurrentPeriodExpenses_totalContainer_1p1Y {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex-wrap: wrap;\n      -ms-flex-wrap: wrap;\n          flex-wrap: wrap;\n}\n\n.CurrentPeriodExpenses_totalField_3oHq {\n  margin-right: 40px;\n  margin-bottom: 20px;\n\n  vertical-align: top;\n\n  font-size: 22px;\n}\n\n.CurrentPeriodExpenses_spendingLimit_3kDQ {\n  margin-right: 40px;\n  margin-bottom: 20px;\n}\n\n.CurrentPeriodExpenses_detalizationButton_GEJm {\n  margin-bottom: 20px;\n}\n", ""]);

// exports
exports.locals = {
	"totalContainer": "CurrentPeriodExpenses_totalContainer_1p1Y",
	"totalField": "CurrentPeriodExpenses_totalField_3oHq",
	"spendingLimit": "CurrentPeriodExpenses_spendingLimit_3kDQ",
	"detalizationButton": "CurrentPeriodExpenses_detalizationButton_GEJm"
};